/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// React
import React, { forwardRef, useEffect } from "react";
// form library
import { Controller, useFormContext } from 'react-hook-form';
// custom components
import LeadNumberedHeading from "../../../../shared-components/forms/LeadNumberedHeading";
import NumberedHeading from "../../../../shared-components/forms/NumberedHeading";
import WYSIWYGEditor from '../../../../shared-components/WYSIWYGEditor';

function DevInfoForm(props) {
  const methods = useFormContext();
  const { control, formState, register } = methods;
  const { errors } = formState;

  return (
    <>
      <LeadNumberedHeading number="3" title="Development Information" instructions="This information is used to store development details about the template." />

      <div className="flex flex-col w-full">
        <NumberedHeading number="1" title="Branching" instructions="Enter a branching information for the template." />
        <Controller
          render={({ field }) => <WYSIWYGEditor {...field} error={errors.branching} />}
          name="branching"
          control={control}
        />

        <NumberedHeading number="2" title="Programming Notes" instructions="Enter a programming notes for the template." />
        <Controller
          render={({ field }) => <WYSIWYGEditor {...field} error={errors.dev_notes} />}
          name="dev_notes"
          control={control}
        />

        <NumberedHeading number="3" title="Graphic Artist Notes" instructions="Enter a graphic artist notes for the template." />
        <Controller
          render={({ field }) => <WYSIWYGEditor {...field} error={errors.ga_notes} />}
          name="ga_notes"
          control={control}
        />

        <NumberedHeading number="4" title="Additional Information" instructions="Enter additional notes for the template." />
        <Controller
          render={({ field }) => <WYSIWYGEditor {...field} error={errors.info} />}
          name="info"
          control={control}
        />
      </div>
    </>
  );
};

export default DevInfoForm;